<template>
    <div id="home">
        <!--canvas-->
        <div id="canvasBox">
            <canvas></canvas>
            <!--文字-->
            <div class="canvasTextWrap">
                <h3>数据驱动未来</h3>
                <span>探索和耕耘企业级⼤数据服务领域</span>
                <span>构建以数据为基础的⽣态，不断为合作伙伴创造价值</span>
            </div>
            <!--遮罩-->
            <div class="canvasShadow"></div>
        </div>
        <!--内容-->
        <div class="contentWrap">
            <!--例子模块-->
            <example></example>
            <!--图片及服务-->
            <imgAndServe></imgAndServe>
            <!--产品矩阵-->
            <product></product>
            <!--我们的客户-->
            <myClient></myClient>
        </div>
    </div>
</template>


<script>
    import homeFun from "../../assets/js/homeScript"
    import example from "./components/example"
    import imgAndServe from "./components/imgAndServe"
    import product from "./components/product"
    import myClient from "./components/myClient"

    export default {
        name: 'home',
        components: {example, imgAndServe, product, myClient},
        data() {
            return {
                updateEvent: null
            }
        },
        mounted() {
            this.updateEvent = homeFun();
            /*淡入淡出效果*/
            this.$animate(document.getElementsByClassName("canvasTextWrap")[0], "fadeInUp");
        }
    }
</script>

<style lang="scss" scoped>
    #home {
        #canvasBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            width: 100%;
            min-width: 1200px;
            height: 700px;
            background: #010101;

            .canvasTextWrap {
                position: absolute;
                z-index: 100;
                margin-top: -40px;

                h3 {
                    font-size: 60px;
                    line-height: 84px;
                    color: #FFFFFF;
                    text-align: center;
                }

                span {
                    display: block;
                    opacity: 0.8;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 28px;
                    margin-top: -4px;
                }
            }

            .canvasShadow {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, .6);
            }
        }

        .contentWrap {
            background: #fff;
        }
    }
</style>
